import injector from 'vue-inject'

/**
 * Service use to handle user authentication
 */
class LoginService {
  constructor(axios, apiRoot) {
    this.axios = axios
    this.apiRoot = apiRoot
  }

  /**
   * Get google authorization url for google sign in
   */
  async signin() {
    const url = `${this.apiRoot}/signin`
    return this.axios.get(url).then(response => response.data)
  }

  /**
   * Sign in custom user
   * @param {*} form
   */
  async signinUser(form) {
    const url = `${this.apiRoot}/signin/user`
    return this.axios.post(url, form).then(response => response.data)
  }

  /**
   * Get user informations after signed in
   * @param {*} email
   * returns: user object
   */
  async getUser(email) {
    const url = `${this.apiRoot}/users/email/${encodeURI(email)}`
    const userResponse = await this.axios.get(url)
    const user = userResponse.data.result
    return user
  }

  /**
   * Sign in custom user
   * @param {*} form
   */
  async getUserAccessToken(email) {
    const url = `${this.apiRoot}/signin/access/token`
    return this.axios.post(url, { email: email }).then(response => response.data)
  }

  /**
   * Sign in custom user
   * @param {*} form
   */
  async refreshTokens(form) {
    const url = `${this.apiRoot}/signin/refresh/token`
    return this.axios.post(url, form).then(response => response.data)
  }

  /**
   * Sign in custom user
   * @param {*} form
   */
  async deleteTokens(refreshToken) {
    const url = `${this.apiRoot}/signin/delete/token`
    const form = { refresh_token: refreshToken }
    return this.axios.delete(url, { data: form }).then(response => response.data)
  }
}

injector.service('loginService', ['axios', 'apiRoot'], LoginService)
